// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import DetailSvg from '@rsuite/icon-font/lib/file/Detail';
var Detail = createSvgIcon({
  as: DetailSvg,
  ariaLabel: 'detail',
  category: 'file',
  displayName: 'Detail'
});
export default Detail;